import { BorderColors, BackgroundColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const BodyCard = styled.div`
	width: 100%;
`;

const PersonAvatar = styled.img`
	width: 20px;
	height: 20px;
	object-fit: cover;
	border-radius: 50%;
`;

const EndUserComment = styled.div`
	border: 1px solid ${BorderColors.Secondary_primary};
	background-color: ${BackgroundColors.BrandUtility50};
	border-radius: 0 ${BorderRadius.MD}px ${BorderRadius.MD}px ${BorderRadius.MD}px;
	padding: 10px 14px;
	margin-bottom: 24px;
`;

export { BodyCard, PersonAvatar, EndUserComment };
